import { UNIT_TRANSLATED, type Unit } from '@enmon/commons';
import { CURRENCY_TRANSLATED, type Currency } from '@enmon/commons/lib/enmon';
import { EmissionScope, EmissionStream } from '@enmon/commons/lib/shared/emissions';

export const CARBON_EMISSIONS_FORM = 'FormCarbonEmission' as const;

export const GHG_INDEXES = Array.from({ length: 18 }).map((_, index) => index - 4);

export enum EmissionTab {
  Records = 'records',
  Factors = 'emission-factors',
}

export interface ScopeAndStreamShape {
  scope: EmissionScope;
  stream: EmissionStream | null;
}

export enum ScopeAndStream {
  One = 'One',
  TwoUpstream = 'TwoUpstream',
  ThreeUpstream = 'ThreeUpstream',
  ThreeDownstream = 'ThreeDownstream',
}

export const SCOPE_AND_STREAM_CONFIG: Record<ScopeAndStream, ScopeAndStreamShape> = {
  [ScopeAndStream.One]: {
    scope: EmissionScope.One,
    stream: null,
  },
  [ScopeAndStream.TwoUpstream]: {
    scope: EmissionScope.Two,
    stream: EmissionStream.Up,
  },
  [ScopeAndStream.ThreeUpstream]: {
    scope: EmissionScope.Three,
    stream: EmissionStream.Up,
  },
  [ScopeAndStream.ThreeDownstream]: {
    scope: EmissionScope.Three,
    stream: EmissionStream.Down,
  },
} as const;

export const getScopeAndStream = (scope: EmissionScope, stream: EmissionStream | null): ScopeAndStream | undefined => {
  switch (scope) {
    case EmissionScope.One: {
      return stream === null ? ScopeAndStream.One : undefined;
    }
    case EmissionScope.Two: {
      return stream === EmissionStream.Up ? ScopeAndStream.TwoUpstream : undefined;
    }
    case EmissionScope.Three: {
      switch (stream) {
        case EmissionStream.Up: {
          return ScopeAndStream.ThreeUpstream;
        }
        case EmissionStream.Down: {
          return ScopeAndStream.ThreeDownstream;
        }
        default: {
          return undefined;
        }
      }
    }
    default:
      return undefined;
  }
};

export const EMISSION_UNIT_TRANSLATED: Record<Unit | Currency, string> = { ...CURRENCY_TRANSLATED, ...UNIT_TRANSLATED };
